/**
 * Shared instantiation logic for the browser and Node entry points.
 */
import wasmInit, {} from "./wasm/rstar_geodetic_wasm.js";
/** The wasm binary, resolved relative to the built JavaScript. */
export const WASM_URL = new URL("./wasm/rstar_geodetic_wasm_bg.wasm", import.meta.url);
let ready;
/**
 * Instantiates the wasm module once; later calls return the same promise. `source`
 * is passed to the wasm-bindgen loader, so it may be a URL, a `Response`, bytes, or a
 * compiled `WebAssembly.Module`. `defaultSource` supplies it when the caller gives
 * none.
 */
export function initOnce(source, defaultSource) {
    if (ready === undefined) {
        ready = wasmInit({ module_or_path: source ?? defaultSource() }).then(() => undefined, (error) => {
            ready = undefined;
            throw error;
        });
    }
    return ready;
}
//# sourceMappingURL=init.js.map